import styled from "styled-components";

export default styled.div`

& {
  width: 100%;
  height: 100%;
  border: 1px solid ${props => props.theme.colors.primary};
  background-color: ${props => props.theme.colors.primary_light};
  padding-left: 20px;
}
button{
  margin-top: 20px;
  margin-bottom: 20px;
}

main{
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: ${props => props.theme.spacing.spacing_04};
  background-color: transparent;
  border:0px;
}


`